import { createFileRoute } from "@tanstack/react-router";
import AssessmentResults from "@/features/assessments/pages/assessment-results/AssessmentResults";

export const Route = createFileRoute("/$locale/$partner/_results/assessment-results")({
	component: AssessmentResults,
});
